const nameToUrls = {
  users: "account",
};
export default nameToUrls;
